import moment from "moment-timezone";
import { useRouter } from "next/router";
import { TYPO } from "styles/Typo";
import { useRelatedDebateList } from "utils/clientAPIs/debate";
import ReportThumb from "components/templates/common/components/ReportThumb";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";

const Item = ({ item, index }: { item: any; index: number }) => {
  const router = useRouter();
  return (
    <TrackedListItem
      itemData={{
        kind: "report",
        report_id: item.id,
        rank: index + 1,
      }}
      href={`/discuss/${
        item?.url_slug ? `${item?.url_slug}-${item?.id}` : item?.id
      }`}
      className="flex  gap-4 w-full cursor-pointer shrink-0 items-start custom-word-break group "
      // onClick={() => {
      //   router.push(
      //     `/discuss/${
      //       item?.url_slug ? `${item?.url_slug}-${item?.id}` : item?.id
      //     }`
      //   );
      // }}
      data-gtm-id={`report-related-agenda-card`}
    >
      <div className="flex flex-col gap-2 grow ">
        <p className={`${TYPO.TYPO5_1_SB} text-gray80 group-hover:text-blue40`}>
          {item.title}
        </p>
        <p className={`${TYPO.TYPO8_RG} text-gray40`}>
          {moment(item.issue_at).format("YYYY.M.D")}
        </p>
      </div>
      <ReportThumb
        data={item}
        width={84}
        className=" rounded-[10px] shrink-0  w-[84px]"
        loading="lazy"
      />
    </TrackedListItem>
  );
};
function ResentAgenda({ discussId }: { discussId: number }) {
  const [relatedAgenda, isValidRelatedAgenda] = useRelatedDebateList(discussId);

  if (isValidRelatedAgenda || !relatedAgenda?.length) return null;

  return (
    <div className="flex flex-col gap-2  ">
      <span className={`${TYPO.TYPO5_SB} text-gray90 px-6 pt-6`}>
        {"관련 글"}
      </span>
      <TrackedList
        listId="report_related_posts_list"
        totalCount={relatedAgenda?.length}
      >
        <div className="px-6 gap-[30px] flex flex-col py-2 ">
          {relatedAgenda?.slice(0, 3)?.map((item: any, index: number) => (
            <Item key={index} item={item} index={index} />
          ))}
        </div>
      </TrackedList>
    </div>
  );
}

export default ResentAgenda;
